// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1679":"4f6edf57","5100":"4f6edf57","7917":"4f6edf57","8697":"2a565394"}[chunkId] + ".chunk.css";
};